module.exports = __webpack_public_path__ + "static/img/7.991c261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/7.png
// module id = AMCE
// module chunks = 0